import { Gear } from "../Gear";

/**
 * The clockwork mechanism — now present in EVERY phase (behind clouds in the
 * morning, behind stars at night). `kick` is the small per-section lurch;
 * `burst` is bumped on every phase change and adds whole extra turns, so the
 * gears whir as if time itself is speeding forward.
 */
export function GearsScene({ kick, burst }: { kick: number; burst: number }) {
  return (
    <div style={{ position: "absolute", inset: 0, overflow: "hidden" }}>
      <Gear size={400} spin={90} teeth={18} spokes={6} opacity={0.24} kick={kick * 40 + burst * 900} position={{ right: -150, bottom: -160 }} />
      <Gear size={210} spin={42} reverse teeth={11} spokes={5} opacity={0.3} kick={-kick * 70 - burst * 1120} position={{ right: 150, bottom: 96 }} />
      <Gear size={280} spin={120} teeth={14} spokes={6} opacity={0.2} kick={kick * 30 + burst * 820} position={{ left: -120, top: -100 }} />
    </div>
  );
}
